import React from 'react';
import PropTypes from 'prop-types';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, PinterestShareButton } from 'react-share';

const SocialShare = ({ url, media, className }) => {
	url = (typeof window != 'undefined' && window.location.origin && window.location.origin + url) || url;

	return (
		<div className={`socialShare flex text-2xl text-black lg:text-3xl ${className || ''}`}>
			<FacebookShareButton url={url}>
				<svg
					stroke='currentColor'
					fill='currentColor'
					strokeWidth='0'
					viewBox='0 0 512 512'
					height='1em'
					width='1em'
					xmlns='http://www.w3.org/2000/svg'
					className='mr-6 block cursor-pointer p-0.5'
				>
					<path d='M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z'></path>
				</svg>
			</FacebookShareButton>
			<TwitterShareButton url={url}>
				<svg
					stroke='currentColor'
					fill='currentColor'
					strokeWidth='0'
					width='0.9em'
					height='0.9em'
					viewBox='0 0 1200 1227'
					xmlns='http://www.w3.org/2000/svg'
					className='mr-6 block cursor-pointer p-0.5'
				>
					<path d='M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z' />
				</svg>
			</TwitterShareButton>
			<LinkedinShareButton url={url}>
				<svg
					stroke='currentColor'
					fill='currentColor'
					strokeWidth='0'
					viewBox='0 0 448 512'
					height='1em'
					width='1em'
					xmlns='http://www.w3.org/2000/svg'
					className='mr-6 block cursor-pointer p-0.5'
				>
					<path d='M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z'></path>
				</svg>
			</LinkedinShareButton>
			{media && (
				<PinterestShareButton
					media={media}
					url={url}
				>
					<svg
						stroke='currentColor'
						fill='currentColor'
						strokeWidth='0'
						viewBox='0 0 496 512'
						height='1em'
						width='1em'
						xmlns='http://www.w3.org/2000/svg'
						className='mr-6 block cursor-pointer p-0.5'
					>
						<path d='M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z'></path>
					</svg>
				</PinterestShareButton>
			)}
		</div>
	);
};

SocialShare.propTypes = {
	url: PropTypes.string.isRequired,
	media: PropTypes.string,
	className: PropTypes.string,
};

export default SocialShare;
